// extracted by mini-css-extract-plugin
export default {"ProviderLogo":"ProviderLogo_ProviderLogo__NGFkN"};